import React from 'react';
import { getMentoringPageContent, getMentoringSharedContent } from '../mentoringContent';
import {
  ActionCard,
  ActionTextLink,
  Card,
  CardGrid,
  Hero,
  Lettered,
  Marquee,
  Pipeline,
  Section,
  Stats,
  Steps,
} from '../components/MentoringPrimitives';
import { MentoringPageShell } from './shared';
import MentoringReels from '../components/MentoringReels';

const ProjectCard = ({ project, locale }) => (
  <Card
    tag={project.tag}
    title={project.title}
    text={project.text}
    href={project.href}
    linkLabel={locale === 'fr' ? 'Voir le produit' : 'Visit product'}
  />
);

const IndexBody = ({ locale }) => {
  const content = getMentoringPageContent(locale, 'index');
  const shared = getMentoringSharedContent(locale);

  if (!content) {
    return null;
  }

  const { hero, pipeline, stats, gap, journey, proof, mentoring, vision, waysIn } = content;

  return (
    <>
      <Hero {...hero} split />

      <Marquee items={shared.marquee} />

      <div className="mt-shell mt-section mt-section--flush">
        <p className="mt-subhead">{pipeline.label}</p>
        <Pipeline steps={pipeline.steps} />
      </div>

      <Section
        marker={gap.marker}
        eyebrow={gap.eyebrow}
        title={gap.title}
        lead={gap.lead}
        tone="paper2"
      >
        <Lettered items={gap.cards} />
      </Section>

      <div className="mt-shell mt-section mt-section--flush">
        <Stats items={stats} />
      </div>

      <Section
        marker={journey.marker}
        eyebrow={journey.eyebrow}
        title={journey.title}
        lead={journey.lead}
        tone="ink"
      >
        <Steps items={journey.steps} />
        <div className="mt-section__actions">
          <ActionTextLink action={journey.link} />
        </div>
      </Section>

      <Section marker={proof.marker} eyebrow={proof.eyebrow} title={proof.title}>
        <div className="mt-section__actions mt-section__actions--end">
          <ActionTextLink action={proof.link} />
        </div>
        <CardGrid cols={3}>
          {proof.projects.map((project) => (
            <ProjectCard key={project.key} project={project} locale={locale} />
          ))}
        </CardGrid>
      </Section>

      <MentoringReels locale={locale} />

      <Section
        marker={mentoring.marker}
        eyebrow={mentoring.eyebrow}
        title={mentoring.title}
        lead={mentoring.lead}
        tone="paper2"
      >
        <CardGrid cols={2}>
          {mentoring.items.map((item) => (
            <Card key={item.number} tag={item.number} title={item.title} text={item.text} />
          ))}
        </CardGrid>
      </Section>

      <Section kicker={vision.kicker} title={vision.title} lead={vision.lead} tone="ink">
        <div className="mt-section__actions">
          <ActionTextLink action={vision.link} />
        </div>
      </Section>

      <Section
        marker={waysIn.marker}
        eyebrow={waysIn.eyebrow}
        title={waysIn.title}
      >
        <CardGrid cols={2}>
          {waysIn.cards.map((card) => (
            <ActionCard
              key={card.key}
              tag={card.tag}
              title={card.title}
              text={card.text}
              action={{ label: card.cta, target: card.target }}
            />
          ))}
        </CardGrid>
      </Section>
    </>
  );
};

export default function MentoringIndexPage({ locale }) {
  return (
    <MentoringPageShell locale={locale} pageKey="index">
      <IndexBody locale={locale} />
    </MentoringPageShell>
  );
}
